import React from 'react'
import { airportCodes } from '../../utils/airportCodes'

const LocationDropdown = ({ location }) => {
  const airportCode = airportCodes(location)

  return (
    <select
      name='Location'
      id='Location'
      aria-label='Select Location'
      type='text'
      className='block h-12 w-full appearance-none rounded-md border border-transparent bg-white py-3 px-4 text-gray-700'
      defaultValue={airportCode || 'LGW'}>
      <optgroup label='Airport'>
        <option value='ABZ'>Aberdeen</option>
        <option value='BHD'>Belfast City (George Best)</option>
        <option value='BFS'>Belfast International</option>
        <option value='BHX'>Birmingham</option>
        <option value='BOH'>Bournemouth</option>
        <option value='BRS'>Bristol</option>
        <option value='CWL'>Cardiff</option>
        <option value='DSA'>Doncaster-Sheffield (Robin Hood)</option>
        <option value='DUB'>Dublin</option>
        <option value='MME'>Durham Tees Valley</option>
        <option value='EMA'>East Midlands</option>
        <option value='EDI'>Edinburgh</option>
        <option value='EXT'>Exeter</option>
        <option value='LGW'>Gatwick</option>
        <option value='GLA'>Glasgow International</option>
        <option value='PIK'>Glasgow Prestwick</option>
        <option value='LHR'>Heathrow</option>
        <option value='HUY'>Humberside</option>
        <option value='INV'>Inverness</option>
        <option value='LBA'>Leeds Bradford</option>
        <option value='LPL'>Liverpool</option>
        <option value='LCY'>London City</option>
        <option value='LTN'>Luton</option>
        <option value='MAN'>Manchester</option>
        <option value='NCL'>Newcastle</option>
        <option value='NWI'>Norwich</option>
        <option value='SNN'>Shannon</option>
        <option value='SOU'>Southampton</option>
        <option value='SEN'>Southend</option>
        <option value='STN'>Stansted</option>
      </optgroup>
      <optgroup label='Port'>
        <option value='DOV'>Dover</option>
        <option value='SOP'>Southampton</option>
      </optgroup>
    </select>
  )
}

export default React.memo(LocationDropdown)
